import { useQuery } from "@tanstack/react-query";
import { sdk } from "@/config/medusa";
import { handleErrorToast } from "@/utils/helpers";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { Product } from "@/types/product";

const useQueryProducts = () => {
  const isAuthenticated = useUser((state) => state.isAuthenticated);
  const vid = storage.getItem("vid");

  const getProducts = async (): Promise<Product[] | undefined> => {
    try {
      const data = await sdk.client.fetch<Product[]>(`/vendor/${vid}/products`);

      return data;
    } catch (e) {
      handleErrorToast(e);
    }
  };

  const query = useQuery({
    queryKey: ["products", vid],
    queryFn: getProducts,
    enabled: isAuthenticated,
  });

  return {
    ...query,
    isFetching: query.isFetching,
  };
};

export default useQueryProducts;
